<template>
  <div class="vertical-positioner">
    <!-- swipe -->
    <div class="swipe">
      <div class="left-slider-right d-flex flex-column justify-content-center align-items-center">
        <div class="slider d-flex align-items-start">
          <img :src="bill_image">
          <div
            class="frame"
            :style="{ 'left': left, 'right': right, 'top': top, 'bottom': bottom }"
          />
        </div>
      </div>
      <div class="feature-description d-flex flex-column">
        <div class="feature-text">
          <p>
            <strong>{{ $t("bills.features." + slug) }}</strong>
            {{ $t("bills.messages." + series + '.' + slug, { denomination }) }}
          </p>
          <img :src="bill_feature">
        </div>
      </div>
    </div>
    <!-- /swipe -->
  </div>
</template>

<script>
// require VueAwesomeSwiper styles
import 'swiper/dist/css/swiper.css';

const featureImages = require.context('@/assets/features/', false);

export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
    top: {
      type: String,
      required: false,
      default: 'auto',
    },
    right: {
      type: String,
      required: false,
      default: 'auto',
    },
    bottom: {
      type: String,
      required: false,
      default: 'auto',
    },
    left: {
      type: String,
      required: false,
      default: 'auto',
    },
    category: {
      type: String,
      required: true,
    },
    side: {
      type: String,
      required: true,
    },
    series: {
      type: String,
      required: true,
    },
    denomination: {
      type: Number,
      required: true,
    },
  },
  computed: {
    bill_feature() {
      return featureImages(`./${this.series}-${this.denomination}-${this.slug}.jpg`);
    },
    bill_image() {
      // Default side to front side for effects with both sides
      let side = 'front';
      if (this.side === 'back') side = this.side;

      return featureImages(`./${this.series}-${this.denomination}_${side}.jpg`);
    },

  },
};

</script>

<style scoped lang="scss">
  .swipe {
    .left-slider-right {
      margin: 100px 0 16px 0;
      @media (max-width: 992px) {
        margin: 32px 0 16px 0;
      }
      .slider {
        position: relative;
        padding: 10px;
        border: 1px solid #9994c2;
        max-width: 600px;
        .flip-box {
          background-color: transparent;
          perspective: 1000px;
          .flip-box-inner {
            position: relative;
            width: 100%;
            height: 100%;
            text-align: center;
            transition: transform 0.5s;
            transform-style: preserve-3d;
            .flip-box-front, .flip-box-back {
              position: absolute;
              width: 100%;
              height: 100%;
              backface-visibility: hidden;
            }
            .flip-box-back {
              transform: rotateY(180deg);
            }
          }
        }
        img {
          width: 100%;
          height: auto;
          text-align: center;
          opacity: 0.8;

        }
        .frame {
          position: absolute;
          border: 2px solid #fff;
        }
      }
    }
    .feature-description {
      max-width: 600px;
      height: auto;
      margin: 0 auto;
      text-align: left;
      p {
        width: auto;
      }
      img {
        display: inline;
        max-width: 160px;
        max-height: 160px;
        margin: 4px 12px 0 0;
        border: 3px solid #fff;
        @media (max-width: 575.98px) {
          max-width: 120px;
          max-height: 120px;
        }
      }
    }
    .icon-flip img{
      margin-top: 36px;
      width: 72px;
      height: 50px;
      opacity: 0.3;
      &:hover {
        opacity: 0.5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bill-list/BillListItemFeature.vue